
const devAnalystConsoleBaseUrl = "https://lemon-meadow-02b88a503.4.azurestaticapps.net";
const prodAnalystConsoleBaseUrl = "https://www.proact2-analystconsole.eu/";
const devCPanelUrl = "https://devetproactcpanel.azurewebsites.net/";
const prodCPanelUrl = "https://www.proact2-controlpanel.eu/";

const getControlPanelBaseUrl = () => {
    return `${prodCPanelUrl}`;
}

const getAnalystConsoleBaseUrl = () => {
    return `${prodAnalystConsoleBaseUrl}`;
}

const generateAnalysisPageUrl = (projectId, userId, messageId) => {
    return `${getAnalystConsoleBaseUrl()}/${projectId}/messages/userId/${userId}/messageId/${messageId}`;
}


export  {
    getControlPanelBaseUrl,
    generateAnalysisPageUrl, 
    getAnalystConsoleBaseUrl
};